export const getToken = () => {
  const oktaTokenStorage = localStorage.getItem("okta-token-storage"); // Value includes idToken and accessToken
  return JSON.parse(oktaTokenStorage).accessToken.accessToken;
};
